import reducer from 'state/salesIntelligence/reducer';
import actions from 'state/salesIntelligence/actionCreators';
import types from 'state/salesIntelligence/actionTypes';
import selectors from 'state/salesIntelligence/selectors';
import effects from 'state/salesIntelligence/effects';

export { actions, effects, types, selectors };

export default reducer;
